/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./AdjustmentDetails.module.css";

const ActionButtons: React.FC = () => {
  return (
    <div className={styles.actionButtons}>
      <div className={styles.leftButtons}>
        <button className={`${styles.actionButton} ${styles.blueButton}`}>
          <span className={styles.buttonText}>Print</span>
        </button>
        <button className={`${styles.actionButton} ${styles.blueButton}`}>
          <span className={styles.buttonText}>Status History</span>
        </button>
      </div>
      <button className={`${styles.actionButton} ${styles.redButton}`}>
        <span className={styles.buttonText}>Delete</span>
      </button>
    </div>
  );
};

export default ActionButtons;
